import { AlertDto } from '@/models/suba/alerts/alert-dto.model';

import { createContext, useContext } from 'react';

export const AlertContext = createContext<AlertDto | undefined>(undefined);

export const useAlertContext = <T extends AlertDto = AlertDto>() =>
  useContext(AlertContext) as T;
